import { useEffect } from "react";

import { useTranslations } from "next-intl";

import * as Dialog from "@/components/dialog/DialogLayout";

export const AlertDialog = ({
  title,
  description,
  isOpen = false,
  onClose,
}: {
  title: string;
  description?: string;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const t = useTranslations();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      e.preventDefault();
      e.stopPropagation();

      if (e.key === "Enter" || e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  return (
    <Dialog.Root open={isOpen} onClose={onClose}>
      <Dialog.Backdrop />
      <Dialog.Container>
        <Dialog.Panel className="max-w-[440px] min-w-[250px]">
          {description ? (
            <>
              <Dialog.Title className="mr-10">{title}</Dialog.Title>
              <p className="mt-2 mb-0 whitespace-pre-line text-gray-600 dark:text-gray-400 text-[15px] leading-[18px]">
                {description}
              </p>
            </>
          ) : (
            <Dialog.Title className="mr-10 font-normal text-size-16 mb-2">{title}</Dialog.Title>
          )}
          <Dialog.Footer>
            <Dialog.Button variant="accent" onClick={onClose}>
              {t("dialog.ok")}
            </Dialog.Button>
          </Dialog.Footer>
          <Dialog.CloseButton>
            <Dialog.CloseIcon />
          </Dialog.CloseButton>
        </Dialog.Panel>
      </Dialog.Container>
    </Dialog.Root>
  );
};
